import React from 'react';
import IMAGES from '../assets/index.js'; // Add .js extension
import { useInView } from 'react-intersection-observer';

function Pictures() {
  // Set up intersection observers for animation triggers
  const [textRef, textInView] = useInView({
    threshold: 0.2,
    triggerOnce: true,
  });
  
  const [imageRef, imageInView] = useInView({
    threshold: 0.2,
    triggerOnce: true,
  });

  return (
    <div className="pictures">
      <div className="container">
        <div className="row align-items-center">
          {/* Left column - Text with animated entrance */}
          <div 
            className={`col-lg-6 col-md-12 impression-text ${textInView ? 'animate__animated animate__fadeInLeft' : ''}`}
            ref={textRef}
          >
            <div className="titlepage text-left">
              <h2>Initial Impressions</h2>
              <span className="text-center d-block">Begin your transformation with us</span>
            </div>
            
            <p className="mb-4">
              Experience the transformative power of yoga as it works to align your body, 
              mind, and spirit in harmony. Through consistent practice, you'll notice improved 
              flexibility, strength, focus, and inner peace.
            </p>

            <p className="mb-4">
            As a professional yoga instructor and certified yoga teacher, 
            I welcome you to Nachiketa Yoga Classes located in Bopal, Ahmedabad.
            </p>
            <a href = "#about"><button className="read_more">Learn More</button></a>
          </div>
          
          {/* Right column - Enhanced image with animation */}
          <div 
            className={`col-lg-6 col-md-12 impression-img ${imageInView ? 'animate__animated animate__fadeInRight' : ''}`}
            ref={imageRef}
          >
            <div className="image-container" style={{ maxWidth: '500px', margin: '0 auto' }}>
              <img 
                src={IMAGES.openart} 
                alt="Yoga Practice" 
                className="main-image"
                style={{ 
                  width: '100%', 
                  height: 'auto',
                  objectFit: 'contain',
                  maxHeight: '500px'
                }}
              />
              <div className="image-overlay">
                <div className="overlay-content">
                  <h3>Find Your Balance</h3>
                  <p>Join our community today</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Pictures;
